<template>
  <b-card :header="caption">
    <b-table
     :hover="hover"
     :striped="striped"
     :bordered="bordered"
     :small="small"
     :fixed="fixed"
     responsive="sm"
     :items="filtered.items"
     :fields="fields"
     :current-page="currentPage"
     :per-page="perPage">
      <template slot="連携定義ID" slot-scope="data">
        <router-link :to="`/pages/edit/${data.item.連携定義ID}`">{{data.item.連携定義ID}}</router-link>
      </template>
      <template slot="status" slot-scope="data">
        <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
      </template>
    </b-table>
    <nav>
      <b-pagination
       :total-rows="getRowCount(filtered.items)"
       :per-page="perPage"
       v-model="currentPage"
       prev-text="前ページ"
       next-text="次ページ" />
    </nav>
      <router-link :to="`/pages/edit`">
          <b-button variant="primary" class="btn-depth pointer">
            <i class="fa fa-plus-circle"></i>&nbsp; 追加</b-button>
      </router-link>

  </b-card>
</template>

<script>
// import IntegrationStore from "../../store/integration";
export default {
  name: "c-table-integrations",
  props: {
    integrations: {
      type: Array,
      default: null
    },
    caption: {
      type: String,
      default: "TableIntegrations"
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fields: [
        { key: "連携定義ID" },
        { key: "定義名" },
        { key: "送信元ID" },
        { key: "送信先ID" },
        { key: "頻度" }
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0
    };
  },
  computed: {
    filtered: function() {
      const items = [];
      const integrations = this.integrations;
      // const integrations = IntegrationStore.state.integrations
      // console.dir(integrations)
      if (integrations && integrations.length > 0) {
        integrations.forEach(item => {
          const sendTo = item.SendTos
            ? item.SendTos.map(target => target["SendToId"]).join(", ")
            : "";
          let ReceiveFromId;
          if (item.ReceiveFroms && item.ReceiveFroms[0] && item.ReceiveFroms[0].ReceiveFromId) {
            ReceiveFromId = item.ReceiveFroms[0].ReceiveFromId;
          } else {
            ReceiveFromId = "***送信元IDが設定されていません***";
          }
          items.push({
            連携定義ID: item.IntegrationId,
            定義名: item.IntegrationName,
            送信元ID: ReceiveFromId,
            送信先ID: sendTo,
            頻度: item.frequency
          }); // , '優先度': item.priority})
        });
      }

      return {
        items: items
      };
    }
  },
  methods: {
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
          ? "secondary"
          : status === "Pending"
            ? "warning"
            : status === "Banned" ? "danger" : "primary";
    },
    getRowCount(items) {
      return items.length;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/base/TableIntegrations.vue